{
  "ru": {
    "errorModal": {
      "ok": "Понятно"
    }
  },
  "kk": {
    "errorModal": {
      "ok": "Түсінікті"
    }
  },
  "en": {
    "errorModal": {
      "ok": "OK"
    }
  }
}
